module.exports = __webpack_public_path__ + "img/alwAlp.c4a30852.png";